type TypeActionNameWithTo = {
  name: string
  to: string
  icon: string
}

type PortletTitleCrudType = {
  create: TypeActionNameWithTo
  read: TypeActionNameWithTo
  update: TypeActionNameWithTo
  delete: TypeActionNameWithTo
}
export type ClientData = {
  cpf: string
  created_at: string
  deleted_at?: string
  email: string
  id: number
  name: string
  status: string
  type: string
  values?: string
  updated_at: string
}

export type ServiceCategoriesData = {
  id: number
  cpf: string
  name: string
  payment_form: string
  status: string
  values: number
  created_at: string
  updated_at: string
  deleted_at?: string
}

const nameEntity = 'ServiceCategory'
const nameSource = 'commercial/serviceCategories'
const namePageTitle = 'Categorias de serviço'
const nameActionPageMain: TypeActionNameWithTo = {
  name: 'Categorias de serviço',
  to: '/commercial/serviceCategories',
  icon: ''
}

const nameActions: PortletTitleCrudType = {
  create: {
    name: 'Adicionar',
    to: '/commercial/serviceCategories/create/',
    icon: 'fa fa-plus'
  },
  read: {
    name: 'Visualizar',
    to: '/commercial/serviceCategories/',
    icon: 'fa fa-list'
  },
  update: {
    name: 'Editar',
    to: '/commercial/serviceCategories/update/',
    icon: 'fa fa-edit'
  },
  delete: {
    name: 'Remover',
    to: '#!',
    icon: 'fa fa-remove'
  }
}

export {
  nameEntity,
  nameSource,
  namePageTitle,
  nameActionPageMain,
  nameActions
}
